import { render, staticRenderFns } from "./first_nav_child.vue?vue&type=template&id=aefdcbba&scoped=true"
import script from "./first_nav_child.vue?vue&type=script&lang=js"
export * from "./first_nav_child.vue?vue&type=script&lang=js"
import style0 from "./first_nav_child.vue?vue&type=style&index=0&id=aefdcbba&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aefdcbba",
  null
  
)

export default component.exports